export var TriggerType;
(function (TriggerType) {
    TriggerType["CONTAINS"] = "CONTAINS";
    TriggerType["ENDS_WITH"] = "ENDS_WITH";
    TriggerType["REGEX"] = "REGEX";
    TriggerType["STARTS_WITH"] = "STARTS_WITH";
    TriggerType["MATCHES"] = "MATCHES";
    TriggerType["CUSTOM_PARAMETER"] = "CUSTOM_PARAMETER";
    TriggerType["NAVIGATION_RANGE"] = "RANGE";
    TriggerType["NAVIGATION_SELECTED"] = "NAVIGATION_SELECTED";
    TriggerType["NAVIGATION_VALUE"] = "VALUE";
})(TriggerType || (TriggerType = {}));
